import type { IconName } from '#/components/Icon/IconName';

import type {
  VolunteerDropdownResourcesItemData,
  VolunteerDropdownSearchItemData,
} from './data/types/VolunteerDropdownData';

export const volunteerDropdownDataBySearchItemType: Record<
  VolunteerDropdownSearchItemData['type'],
  { iconName: IconName; qaId: string; trackClickedName: string }
> = {
  volop: {
    iconName: 'hand',
    qaId: 'nav-volop-link',
    trackClickedName: 'Volunteer',
  },
  event: {
    iconName: 'star-calendar',
    qaId: 'nav-event-link',
    trackClickedName: 'Attend an Event',
  },
  organizations: {
    iconName: 'building',
    qaId: 'nav-organizations-link',
    trackClickedName: 'Organizations',
  },
  'post-a-listing': {
    iconName: 'pin',
    qaId: 'nav-post-listing-link',
    trackClickedName: 'Post a Listing',
  },
};

export const volunteerDropdownDataByResourcesItemType: Record<
  VolunteerDropdownResourcesItemData['type'],
  { image: string; imageHover: string; qaId: string; trackClickedName: string }
> = {
  'idealist-movement': {
    image: 'illustrations/announce-illustration.svg',
    imageHover: 'illustrations/announce-illustration-hover.svg',
    qaId: 'nav-idealist-movement-link',
    trackClickedName: 'Idealist Movement',
  },
  'knowledge-base': {
    image: 'illustrations/salary-illustration.svg',
    imageHover: 'illustrations/salary-illustration-hover.svg',
    qaId: 'nav-knowledge-base-link',
    trackClickedName: 'Knowledge Base',
  },
  'recipes-for-action': {
    image: 'illustrations/star-illustration.svg',
    imageHover: 'illustrations/star-illustration-hover.svg',
    qaId: 'nav-recipes-for-action-link',
    trackClickedName: 'Recipes For Action',
  },
  blog: {
    image: 'illustrations/announce-illustration.svg',
    imageHover: 'illustrations/announce-illustration-hover.svg',
    qaId: 'nav-blog-link',
    trackClickedName: 'Blog',
  },
  'volunteer-resources': {
    image: 'illustrations/article-illustration.svg',
    imageHover: 'illustrations/article-illustration-hover.svg',
    qaId: 'nav-volunteer-resources-link',
    trackClickedName: 'Volunteer Resources',
  },
};
